export interface ComponentType {
  id: string;
  name: string;
}

export const COMPONENT_TYPES: ComponentType[] = [
  { id: 'Drink', name: 'Drink' },
  { id: 'Side', name: 'Side' },
];

